// libs
import styled, { css } from 'styled-components'
// icons
import UploadIconOrigin from '@mui/icons-material/Upload'
// themes
import colors from 'themes/colors'
// static
import CloseIconOrigin from '@mui/icons-material/Cancel'
// utils
import { darken, size } from 'polished'

export const CloseIcon = styled(CloseIconOrigin)<any>`
  && {
    min-width: 18px;
    cursor: pointer;
    margin-left: auto;
  }

  path {
    fill: ${colors.gray450};
  }

  &:hover {
    path {
      fill: ${darken(0.1, colors.gray450)};
    }
  }

  ${size('18px')};
`

export const Link = styled.a<{ isDisabled: boolean }>`
  color: ${({ isDisabled }) => (isDisabled ? colors.gray320 : colors.black)};
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #a7a7a7;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Dropzone = styled.div<{ $isDragActive: boolean; $disabled?: boolean }>`
  align-items: center;
  border: 1px dashed ${({ $isDragActive }) => ($isDragActive ? colors.blue500 : colors.gray320)};
  border-radius: 6px;
  display: flex;
  justify-content: center;
  min-height: 60px;
  outline: none;
  padding: 8px 16px;
  text-align: center;
  margin-top: 6px;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `};
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`

export const Text = styled.div`
  font-size: 16px;
`

export const ActionLink = styled.span`
  color: ${colors.blue500};
  cursor: pointer;
`

export const UploadIcon = styled(UploadIconOrigin)`
  ${size('28px')};

  path {
    fill: ${colors.blue500};
  }
`

export const LinkWrapper = styled.div`
  align-items: center;
  display: flex;
  min-height: 32px;
  gap: 12px;
  border-bottom: 1px solid gray;
  padding-bottom: 1px;

  &:hover {
    padding-bottom: 0;
    border-bottom: 2px solid black;
  }
`
